import clone from 'lodash/clone';

import { getRandomInt } from '../../sov';
import {
  TAB_LABELS,
  convertItemToCheckbox,
  getActiveQuery,
  getSingular
} from '../sov-queries';

import type { CheckboxesListItem } from 'types';
import type {
  SOVGeneralItem,
  SOVQueryLocal,
  SOVQuerySearchResultsEndpoint,
  SOVQueryStepType
} from 'modules/insights/sov/types';

type ActiveKeywords = {
  [x: string]: Array<SOVGeneralItem>
};

export const DEFAULT_RESULTS_MAP = {
  hashtags: [],
  mentions: [],
  tags: []
};

export const getDefaultResultsMap = (): any => ({
  single: clone(DEFAULT_RESULTS_MAP),

  primary: clone(DEFAULT_RESULTS_MAP),
  secondary: clone(DEFAULT_RESULTS_MAP)
});

export const getActiveKeywords = (activeQuery: Partial<SOVQueryLocal>, stepType: SOVQueryStepType): ActiveKeywords => {
  const { includedKeywords, customKeywords, channels } = activeQuery;

  if (!includedKeywords || !customKeywords || !channels) {
    return {};
  }

  const keywords = {
    includedKeywords: includedKeywords[stepType],
    customKeywords: customKeywords[stepType],
    channels: channels[stepType]
  };

  return {
    includedKeywords: keywords.includedKeywords.general,
    customKeywords: keywords.customKeywords.general,
    channels: keywords.channels.general
  };
};

export const getPreparedIncludedKeywords = (
  queryId: number,
  stepType: SOVQueryStepType,
  results: SOVQuerySearchResultsEndpoint,
  mergedQueries: Array<SOVQueryLocal>
): Partial<SOVQuerySearchResultsEndpoint> => {
  const activeQuery = getActiveQuery(queryId, mergedQueries);
  const activeKeywords = getActiveKeywords(activeQuery, stepType);
  const updatedResults = clone(DEFAULT_RESULTS_MAP);

  TAB_LABELS.forEach(tab => {
    const compareKeywords = (activeKeywords.includedKeywords || [])
      .filter(item => item.type === getSingular(tab));

    updatedResults[tab] = results[tab].map(item => ({
      ...item,
      selected: compareKeywords.some(k => k.keyword === item.keyword)
    }));
  });

  return updatedResults;
};

export const getPreparedCustomKeywords = (
  queryId: number,
  stepType: SOVQueryStepType,
  mergedQueries: Array<SOVQueryLocal>
): Partial<SOVQuerySearchResultsEndpoint> => {
  const activeQuery = getActiveQuery(queryId, mergedQueries);
  const activeKeywords = getActiveKeywords(activeQuery, stepType);
  const updatedResults = clone(DEFAULT_RESULTS_MAP);

  TAB_LABELS.forEach(tab => {
    const compareKeywords = (activeKeywords.customKeywords || [])
      .filter(item => item.type === getSingular(tab));

    updatedResults[tab] = compareKeywords;
  });

  return updatedResults;
};

export const getCustomValueCheckbox = (value: string, type: string): CheckboxesListItem => {
  const formattedValue = {
    count: 0,
    keyword: value,
    type
  };

  const convertedItem = convertItemToCheckbox(formattedValue, getRandomInt(9999));

  return {
    ...convertedItem,
    isSelected: true
  };
};
